export default __webpack_public_path__ + "static/media/card-rebates.43bb1aaf.svg";